export default "__VITE_ASSET__Drm0zL44__"